<template lang="pug">
  .layout-service.bg-alt
    side-nav(:content="menuItems", :access="account.user.type")
    .content.pb-5
      transition(name="page", mode="out-in")
        router-view
</template>

<script>
import SideNav from '@/components/structure/SideNav';
import { mapState } from 'vuex';

export default {
  name: 'LayoutService',
  components: {
    SideNav,
  },
  data() {
    return {
      menuItems: {
        title: 'Artist Panel',
        items: [
          {
            label: 'DASHBOARD',
            route: 'Dashboard',
          },
          {
            label: 'ARTISTS',
            route: 'Artists',
          },
          {
            label: 'CUSTOMERS',
            route: 'Customers',
          },
          {
            label: 'RENTALS',
            route: 'Rentals',
          },
          {
            label: 'ORDERS',
            route: 'Orders',
          },
          // {
          //   label: 'Shipments',
          //   route: 'Shipments',
          // },
          {
            label: 'PAYOUTS',
            route: 'PayoutsEligible',
          },
          {
            label: 'ART',
            route: 'Art',
          },
          {
            label: 'CONTENT',
            route: 'ContentFaq',
          },
          {
            label: 'REPORTS',
            route: 'ReportsRentals',
          },
          {
            label: 'ACCOUNT',
            route: 'AccountProfile',
          },
          // {
          //   label: 'Analytics',
          //   route: 'Analytics',
          //   disabled: true,
          // },
          // {
          //   label: 'Configuration',
          //   route: 'Config',
          // },
        ],
      },
    };
  },
  methods: {
  },
  computed: {
    ...mapState('account', ['account']),
  },
};
</script>

<style lang="scss" scoped>
  .layout-service {
    display: flex;
    position: relative;
    min-height: 100vh;
  .content {
    overflow-x: hidden;
    flex-grow: 1;
  }
  // Router transition
  }
  .page-enter-active, .page-leave-active {
    transition: transform 0.2s;
  }
  .page-enter {
    transform: translateX(100%);
  }
  .page-leave-to {
    transform: translateX(100%);
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/LayoutService.vue